import { createRouter, createWebHashHistory  } from 'vue-router'
import Home from '../views/Home.vue'
import Order from "../views/order/Order";
import OrderBeta from '../views/order/Order-Beta.vue';
import HelpCenter from "../views/help-center/Help-Center"
import ContactCustomer from "../views/contact-customer/Contact-Customer"
import OrderEnquiry from "../views/order-enquiry/Order-Enquiry"
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/helpcenter/:hashcode',
    name: 'HelpCenter',
    component: HelpCenter
  },
  {
    path: '/helpcenter/status/:hashcode',
    name: 'Order',
    component: Order,
  },
  {
    path: '/helpcenter/statusbeta/:hashcode',
    name: 'OrderBeta',
    component: OrderBeta,
  },
  {
    path: '/helpcenter/order/contactCustomer/:hashcode',
    name: 'ContactCustomer',
    component: ContactCustomer,
  },
  {
    path: '/helpcenter/enquiry/:hashcode',
    name: 'OrderEnquiry',
    component: OrderEnquiry,
  }
]

const router = createRouter({
  //history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes
})

export default router
